export default {
  jcutrell: {
    name: 'Jonathan Cutrell',
    twitterUsername: 'jcutrell',
    profilePhotoUrl: '/static/img/hosts/jcutrell.jpg',
  },

  superbryntendo: {
    name: 'Bryn Jackson',
    twitterUsername: 'superbryntendo',
    profilePhotoUrl: '/static/img/hosts/superbryntendo.jpg',
  },

  soffes: {
    name: 'Sam Soffes',
    twitterUsername: 'soffes',
    profilePhotoUrl: '/static/img/hosts/soffes.jpeg',
  },

  brian_lovin: {
    name: 'Brian Lovin',
    twitterUsername: 'brian_lovin',
    profilePhotoUrl: '/static/img/hosts/brian_lovin.jpeg',
  },

  schrockwell: {
    name: 'Rockwell Schrock',
    twitterUsername: 'Schrockwell',
    profilePhotoUrl: '/static/img/hosts/schrockwell.png',
  },

  seanwashbot: {
    name: 'Sean Washington',
    twitterUsername: 'seanwashbot',
    profilePhotoUrl: '/static/img/hosts/seanwashbot.jpg',
  },

  marshallbock: {
    name: 'Marshall Bock',
    twitterUsername: 'marshallbock',
    profilePhotoUrl: '/static/img/hosts/marshallbock.png',
  },

  sortino: {
    name: 'Joshua Sortino',
    twitterUsername: 'sortino',
    profilePhotoUrl: '/static/img/hosts/sortino.jpg',
  },

  sarahberus: {
    name: 'Sarah Marie',
    twitterUsername: 'sarahberus',
    profilePhotoUrl: '/static/img/hosts/sarahberus.jpeg',
  },

  donnfelker: {
    name: 'Donn Felker',
    twitterUsername: 'donnfelker',
    profilePhotoUrl: '/static/img/hosts/donnfelker.jpg',
  },

  kaushikgopal: {
    name: 'Kaushik Gopal',
    twitterUsername: 'kaushikgopal',
    profilePhotoUrl: '/static/img/hosts/kaushikgopal.jpg',
  },

  calebd: {
    name: 'Caleb Davenport',
    twitterUsername: 'calebd',
    profilePhotoUrl: '/static/img/hosts/calebd.jpg',
  },

  mrbrettkelly: {
    name: 'Brett Kelly',
    twitterUsername: 'mrbrettkelly',
    profilePhotoUrl: '/static/img/hosts/mrbrettkelly.jpg',
  },

  cfoandrew: {
    name: 'Andrew Carroll',
    twitterUsername: 'cfoandrew',
    profilePhotoUrl: '/static/img/hosts/cfoandrew.jpg',
  },

  jesse_squires: {
    name: 'Jesse Squires',
    twitterUsername: 'jesse_squires',
    profilePhotoUrl: '/static/img/hosts/jesse_squires.jpg',
  },

  simjp: {
    name: 'JP Simard',
    twitterUsername: 'simjp',
    profilePhotoUrl: '/static/img/hosts/simjp.jpg',
  },

  una: {
    name: 'Una',
    twitterUsername: 'una',
    profilePhotoUrl: '/static/img/hosts/una.jpg',
  },

  chrisdhanaraj: {
    name: 'Chris Dhanaraj',
    twitterUsername: 'chrisdhanaraj',
    profilePhotoUrl: '/static/img/hosts/chrisdhanaraj.jpg',
  },

  vernalkick: {
    name: 'Kevin Clark',
    twitterUsername: 'vernalkick',
    profilePhotoUrl: '/static/img/hosts/vernalkick.jpeg',
  },

  rafahari: {
    name: 'Rafael Conde',
    twitterUsername: 'rafahari',
    profilePhotoUrl: '/static/img/hosts/rafahari.jpg',
  },

  luperdev: {
    name: 'Drew Luper',
    twitterUsername: 'luperdev',
    profilePhotoUrl: '/static/img/hosts/luperdev.jpg',
  },

  _mikhailbot: {
    name: 'Mikhail Delport',
    twitterUsername: '_mikhailbot',
    profilePhotoUrl: '/static/img/hosts/mikhailbot.jpg',
  },
  therobhayes: {
    name: 'Robert Hayes',
    twitterUsername: 'therobhayes',
    profilePhotoUrl: '/static/img/hosts/robhayes.jpg',
  },
  tomcreighton: {
    name: 'Tom Creighton',
    twitterUsername: 'tomcreighton',
    profilePhotoUrl: '/static/img/hosts/tomcreighton.jpg',
  },
  chantastic: {
    name: 'Michael Chan',
    twitterUsername: 'chantastic',
    profilePhotoUrl: '/static/img/hosts/chantastic.jpg',
  },
}
